import {useContext} from 'react';
import DatePickerContext, {
  DatePickerContextProps,
} from '@/contexts/datePickerContext';

const useDatePickerContext = (): DatePickerContextProps => {
  const context = useContext(DatePickerContext);

  if (!context) {
    throw new Error(
      'useDatePickerContext must be used within an VillageContextProvider',
    );
  }

  return context;
};

export default useDatePickerContext;
